import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
export default function WhatsAppBot() {
  const [showPopup, setShowPopup] = useState(false);
  const handleYes = () => {
    window.open('https://wa.me/917909111007', '_blank');
    setShowPopup(false);
  };
  return <>
      {/* Floating WhatsApp Button */}
      <div onClick={() => setShowPopup(true)} className="fixed bottom-20 right-20 z-50 cursor-pointer bg-green-500 rounded-full p-3 drop-shadow-xl hover:scale-105 transition-all duration-300 sm:bottom-12 sm:right-12">
        <MessageCircle className="w-8 h-8 text-white" />
      </div>

      {/* Confirmation Popup */}
      {showPopup && <div className="fixed bottom-36 right-15 z-50 bg-white rounded-xl shadow-lg p-4 w-72 border animate-fade-in sm:bottom-28 sm:right-25">
          <p className="text-sm font-medium text-gray-800 mb-3">
            Would you like to chat with our team in WhatsApp?
          </p>
          <div className="flex justify-end space-x-3">
            <button onClick={() => setShowPopup(false)} className="text-gray-500 hover:text-red-500 transition-colors">
              ❌ No
            </button>
            <button onClick={handleYes} className="text-green-600 font-semibold hover:underline transition-colors">
              ✅ Yes
            </button>
          </div>
        </div>}
    </>;
}